import { Loader2 } from "lucide-react";

import { cn } from "@/utils";

type LoadingScreenProps = {
  className?: string;
};

export function LoadingScreen(props: LoadingScreenProps) {
  const { className } = props;
  return (
    <div className={cn("flex h-full items-center justify-center", className)}>
      <Loader2 className="h-12 w-12 animate-spin text-primary" />
    </div>
  );
}
